import SetupGoals from './setup-goals'

export default SetupGoals
